import { createSlice } from '@reduxjs/toolkit';
import { fetchAgentTotalStats } from './agentDashboardAPI';
import {
  convertToMinutes,
  momentCustomInstance as moment,
} from '../../app/common/libs/helper';

export const initialState = {
  isDashboardModalOpen: false,
  startDate: moment().startOf('day').format(),
  endDate: moment().endOf('day').format(),
  selectedCampaign: {},
  campaigns: [],
  totalStats: {
    loading: false,
    error: null,
    data: {},
  },
};

export const agentDashboardSlice = createSlice({
  name: 'agentDashboardSlice',
  initialState,
  reducers: {
    setDate: (state, { payload: { start, end } }) => {
      state.startDate = start;
      state.endDate = end;
    },
    setIsDashboardModalOpen: (state, action) => {
      state.isDashboardModalOpen = action.payload;
    },
  },
  extraReducers: {
    [fetchAgentTotalStats.pending]: (state) => {
      state.totalStats.loading = true;
    },
    [fetchAgentTotalStats.rejected]: (state, { meta, error }) => {
      state.totalStats.loading = false;
      state.totalStats.data = {};
      state.totalStats.error = error;
    },
    [fetchAgentTotalStats.fulfilled]: (state, { meta, payload: { data } }) => {
      state.totalStats.loading = false;
      state.totalStats.error = '';
      state.totalStats.data = {
        ...data,
        avgResponseTime: convertToMinutes(data.avgResponseTime),
      };
    },
  },
});

export const { setDate, setIsDashboardModalOpen } = agentDashboardSlice.actions;
export default agentDashboardSlice.reducer;
